import React from "react";

const SERVICE_CARDS = [
  { label:"Food & Beverages", img:"https://images.unsplash.com/photo-1555244162-803834f70033?w=600&q=80", href:"/Food",  desc:"Choose the perfect food combo for your celebration." },
  { label:"Cakes",            img:"https://images.unsplash.com/photo-1464349095431-e9a21285b5f3?w=600&q=80", href:"/cakes", desc:"Choose the perfect cake from our delicious selection." },
  { label:"Screening",        img:"https://images.unsplash.com/photo-1489599849927-2ee91cede3ba?w=600&q=80", href:null,    desc:"Bring your OTT account and relive the theatre magic!" },
  { label:"Bouquets",         img:"https://images.unsplash.com/photo-1487530811015-780fb69d5cb4?w=600&q=80", href:null,    desc:"Add a beautiful rose bouquet to your celebration." },
  {label:"Photography",         img:"https://images.unsplash.com/photo-1508214751196-bcfd4ca60f91?w=600&q=80", href:null,    desc:"Capture your moments with our professional photography." },   
];

export default function ServicesSection() {
  return (
    <section className="cc-sec cc-sec-white" style={{ overflow:"hidden" }}>
      <div className="container">
        <div className="text-center rv" style={{ marginBottom:52 }}>
          <span className="cc-tag">✦ Our Services ✦</span>
          <h2 className="cc-h">Everything You <span>Need</span></h2>
          <p className="cc-sub">Cakes, food, screening, bouquets — all curated to make your event absolutely perfect.</p>
        </div>
        <div style={{ display:"flex", alignItems:"center", gap:16, marginBottom:52 }}>
          <div style={{ flex:1, height:1, background:"linear-gradient(90deg,transparent,rgba(94,14,115,.15),transparent)" }} />
          <div style={{ width:8, height:8, background:"#C9A84C", transform:"rotate(45deg)", flexShrink:0 }} />
          <div style={{ flex:1, height:1, background:"linear-gradient(90deg,rgba(94,14,115,.15),transparent)" }} />
        </div>
        <div className="svc-grid rv">
          {SERVICE_CARDS.map((s, i) => (
            <div key={i} className="svc-card-premium">
              <div className="svc-img-wrap">
                <img src={s.img} alt={s.label} className="svc-img-premium" loading="lazy" />
                <div className="svc-glow-ovl" />
                <div className="svc-num-badge">0{i + 1}</div>
                <div className="svc-pill-tag">{["✨ Popular","🎂 Custom","🎬 Cinematic","🌹 Fresh"][i]}</div>
              </div>
              <div className="svc-body-premium">
                <div className="svc-float-icon">{["🍽️","🎂","🎬","🌹"][i]}</div>
                <div className="svc-title-premium">{s.label}</div>
                <span className="svc-anim-line" />
                <p className="svc-desc-premium">{s.desc}</p>
                {s.href && <a href={s.href} className="svc-view-link">View More <span className="svc-link-arr">→</span></a>}
              </div>
            </div>
          ))}
        </div>
        <div className="text-center" style={{ marginTop:8 }}>
          <a href="https://wa.me/918341428342" target="_blank" rel="noopener noreferrer"
            className="wa-btn" style={{ margin:"0 auto" }}>
            <i className="bi bi-whatsapp" /> Chat With Us
          </a>
        </div>
      </div>
    </section>
  );
}